// src/components/controller/ShareModal.js
import { Modal, ModalHeader, ModalBody, ModalFooter, ModalButton } from 'baseui/modal';
import { Button } from 'baseui/button';
import { Input } from 'baseui/input';
import QRCode from 'qrcode.react';
import { useLocale } from '../../contexts/LocaleContext';
import { ShareModalContent, ShareUrlInput, QrCodeWrapper } from '../../styles/controllerPageStyles';
import { CopyIcon } from '../../styles/iconStyles';

const ShareModal = ({ isOpen, onClose, displayUrl, copyToClipboard }) => {
  const { t } = useLocale();

  return (
    <Modal onClose={onClose} isOpen={isOpen}>
      <ModalHeader>{t('tournament.shareTournament')}</ModalHeader>
      <ModalBody>
        <ShareModalContent>
          <ShareUrlInput>
            <Input value={displayUrl} readOnly />
            <Button onClick={copyToClipboard} size="compact">
              <CopyIcon />
            </Button>
          </ShareUrlInput>
          <QrCodeWrapper>
            <QRCode value={displayUrl} size={256} />
          </QrCodeWrapper>
        </ShareModalContent>
      </ModalBody>
      <ModalFooter>
        <ModalButton onClick={onClose}>{t('common.close')}</ModalButton>
      </ModalFooter>
    </Modal>
  );
};

export default ShareModal;
